import Select from 'App/components/fields/Nebula/SelectField'

export default Select
